export const SIGNOUT_USER_ON_AUTHENTICATION_FAIL = 'SIGNOUT_USER_ON_AUTHENTICATION_FAIL';
export const BLOCKING_LOADER = 'BLOCKING_LOADER';
export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';
export const APP_INIT_ERROR = 'APP_INIT_ERROR';
export const GET_ASSOCIATED_HOTELS = 'GET_ASSOCIATED_HOTELS';